import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToCopeWithSetbacks');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">‘A final thought’</div>
                                            <p>
                                                Fear of failure is common to many of us but people can just as
                                                easily be hampered by fear of
                                                achievement. Often, people don’t do things they’re capable of
                                                because they want to ‘fit in’, rather
                                                than be set apart by success. Being good or ‘the best’ at
                                                something can be lonely and the
                                                pressure of people’s expectations can itself prove to be a
                                                setback.
                                            </p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToRaiseEnergyLevels')}
                                                        className="link_color task button-link-redirect">How to raise energy
                                                        levels</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color task button-link-redirect">How to reframe problems</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeControl')}
                                                        className="link_color task button-link-redirect">How to take control</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMaintainMomentum')}
                                                        className="link_color task button-link-redirect">How to maintain momentum</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFormulateActionPlans')}
                                                        className="link_color task button-link-redirect">How to formulate action
                                                        plans</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBuildResilience')}
                                                        className="link_color task button-link-redirect">How to build resilience</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToUseOptimismToAchieve')}
                                                        className="link_color task button-link-redirect">How to use optimism to
                                                        achieve.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Kobasa, S. (1979).
                                                    Stressful life events, personality, and health: An inquiry
                                                    into hardiness. <span className="subtiltereg">Journal of
Personality and Social Psychology, 37,</span> 1-11.</p></li>

                                                <li><p className="further_info_content">Caza, B.
                                                    B., &amp; Milton, L. P. (2012). Resilience at work: Building
                                                    capability in the face of adversity. <span
                                                        className="subtiltereg">The Oxford
handbook of positive organizational scholarship,</span> 895-908.</p></li>
                                                <li><p className="further_info_content">Lindenfield, G.
                                                    (1999). <span
                                                        className="subtiltereg">Success from Setbacks.</span> Harper
                                                    Collins.</p></li>
                                                <li><p className="further_info_content">Adapted from “CBT
                                                    Training Course for Relate counselling training”, East
                                                    London University (1997).</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}